// 表示価格は Markets のカタログ割増と動的 FX でストア側が決めるため、
// BaseHub のマスタ価格ではなく Shopify の AJAX API から取得する。
// 1 生地 = 1 コレクション = 1 商品 の構造なので collection_handle で引ける。

const cache = new Map();

export const getPriceContext = () => {
  const el = document.getElementById('mtm-fabric-selector');
  return {
    country: el?.dataset.country || '',
    currency: el?.dataset.currency || ''
  };
};

export const formatMoney = (value, currency) => {
  const amount = Number(value);
  if (!isFinite(amount)) return '';
  if (currency) {
    try {
      return new Intl.NumberFormat(document.documentElement.lang || undefined, {
        style: 'currency',
        currency
      }).format(amount);
    } catch (e) {
      // 通貨コードが不正な場合は素の数値へフォールバック
    }
  }
  return String(value);
};

// 未生成のコレクション（BaseHub → Shopify 同期のタイムラグ）は null を返し、価格非表示にする
const fetchPrice = async (collectionHandle, country) => {
  // API のレスポンスは大文字混じりで返るが、コレクション URL は小文字でないと 404 になる
  const handle = String(collectionHandle).toLowerCase();
  const key = `${handle}|${country}`;
  if (cache.has(key)) return cache.get(key);

  const params = new URLSearchParams({ limit: '1' });
  if (country) params.set('country', country);

  const promise = fetch(`/collections/${handle}/products.json?${params}`, {
    credentials: 'same-origin'
  })
    .then((res) => (res.ok ? res.json() : null))
    .then((json) => json?.products?.[0]?.variants?.[0]?.price ?? null)
    .catch(() => null);

  cache.set(key, promise);
  return promise;
};

// 生地一覧 1 ページぶん（24 件）をまとめて取得し、collection_handle → 表示価格 の辞書にする
export const fetchFabricPrices = async (collectionHandles) => {
  const { country, currency } = getPriceContext();
  const handles = collectionHandles.filter(
    (handle, index) => handle && collectionHandles.indexOf(handle) === index
  );

  const entries = await Promise.all(
    handles.map(async (handle) => {
      const price = await fetchPrice(handle, country);
      return [handle, price === null ? null : formatMoney(price, currency)];
    })
  );

  return entries.reduce((acc, [handle, price]) => {
    acc[handle] = price;
    return acc;
  }, {});
};
